module.exports = __webpack_public_path__ + "img/audi-event6.4f2b58e9.jpg";